import { useRef, memo } from "react";
import { UploadBtnWrapper, UploadButton, LoadingSpinner } from "./style";
const FileUploadBtn = memo((props) => {
  const { onFileUpload, loading, fileName } = props;
  const inputRef = useRef();
  const handleButtonClick = (event) => {
    event.preventDefault();
    inputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = inputRef.current.files[0];
    onFileUpload(file); // 여기서 받은 file 을 dispath 하는 함수 넘겨준다.
  };

  return (
    <UploadBtnWrapper>
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        name="file"
        onChange={handleFileChange}
      ></input>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <UploadButton type="button" onClick={handleButtonClick}>
          {fileName || "이미지 업로드"}
        </UploadButton>
      )}
    </UploadBtnWrapper>
  );
});

export default FileUploadBtn;
